import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Router, ActivatedRoute } from '@angular/router';
import { Angular2CsvModule } from 'angular2-csv';
import { AuthenticationService } from '../service/authentication.service';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-new-user-by-bank',
  templateUrl: './new-user-by-bank.component.html',
  styleUrls: ['./new-user-by-bank.component.css']
})
export class NewUserByBankComponent implements OnInit {

  newUserName : string ='';
  confirmUserName : string ='';
  newPass : string ='';
  confirmPassword : string ='';
  captchaInput : string ='';
  otp : string ='';
  newUserOtpdata : any;
  isLoad : boolean =false;
  storedOtp : string ='';
  isshow : string ='page';
  captcha : string ='';
  oldUserName : string ='';
  oldPassword : string ='';
  otpResponse : any;
  error:any;
  messageNewUserreq:string;
  msgforNewUserNoSpace:string;
  Errorflaguser:string;
  regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    regchar='/^[a-zA-Z]+$/';
    regexpspace=/\s+/;
    regZeroOnly='^[0][0]*[0]$';
    regNum = /^.*[0-9]/;
    regexcap =/^.*?[A-Z]/;
    messageConfUserreq:string;
    Errorflag1:string;
    msgforConfUserNoSpace:string;
     messageFormNewPassreq:string;
    msgforNewPassSplChar:string;
    msgforNewPassLen:string;
    messageForOneCapital:string;
    messageForOneNumber:string;
    msgforNewPassSpace:string;
    msgConfPassrequired:string;
    confpassNotMatch:string;
    msgOtprequired:string;
    captchatNoblank:string;
    msgForDateReq:string;
    incorrectCaptcha:string;
    Errorflagac:string="no";
      ErrorflagCfUser:string="no";
     Errorflagcap:string="no";
     ErrorflagCfPass:string="no";
     ErrorflagPass:string="no";
     ErrorflagOtp:string="no";
     isError1:boolean=false;
     returnUrl:string;
 //  rForm: FormGroup;
     errorDescription:string="";
  bankName: any;
  contactUsPage: string;
  atmBranch: string;
    
  constructor(private webService: CallBackEndService,
    private router: Router,
    private route: ActivatedRoute,
     private logoutCall: AuthenticationService,
     private toastr:  ToastrService,
     private http: HttpClient
  ) { 
    this.bankName = webService.getBankName();
    this.getJSON().subscribe(data => {
      this.atmBranch = data.atmBranch;
      this.contactUsPage = data.contactUsPage;
     });    
    
 this.captcha= this.getCaptcha()+"";
    
    this.oldUserName=sessionStorage.getItem('storedUserName');
    this.oldPassword=sessionStorage.getItem('storedPassword');
  }
 public getJSON(): Observable<any> {
      return this.http.get('assets/SampleUrl.json'); 
    }
  ngOnInit() {
  

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/show-success';
     this.getCaptcha();
  }
   getCaptcha()
{
    var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
        'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
        'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
        'u', 'v', 'w', 'x', 'y', 'z');
    var i;
    for (i = 0; i < 6; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = alpha[Math.floor(Math.random() * alpha.length)];
      var f = alpha[Math.floor(Math.random() * alpha.length)];
      var g = alpha[Math.floor(Math.random() * alpha.length)];
    }
    var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f
        + ' ' + g;
   this.captcha = code;
  
  }

  goToLink1(){
    //  window.open('http://www.abhinavbank.com/branch.asp','_blank');
    window.open(this.atmBranch,'_blank');

    //window.location.href='#/Disclaimer';
  }
  goToLink2(){
    // window.open('https://www.maheshbankpune.in/contact-us.html','_blank');
    // window.open('http://www.abhinavbank.com/contact.asp','_blank'); 
    window.open(this.contactUsPage,'_blank'); 

  }
  
  
    getOtp() {
    
  // this.router.navigate([this.returnUrl]);
    
    /*  const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      
      request.param1 = getHexAscii('',sessionStorage.getItem('oldUserName'));
      request.param2 =sessionStorage.getItem('oldUserName');
  
      this.webService.getResponse(request, 'generateOtpUserByBank').subscribe((data: IbResponse) => {
       
          this.newUserOtpdata = data;
        if (response.status === 'S200') {
          this.storedOtp=this.newUserOtpdata.param1;
        } else if (response.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
        } else {
          
          // tslint:disable-next-line:no-unused-expression
          this.newUserOtpdata.statusDescription;
          this.errorDescription = response.param1;
          this.isLoad = false;
        }
      });*/
      //this.isShow = 'show1';
  const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1 = getHexAscii('', 'tarun');
      request.param2 = 'tarun';
      this.webService.getResponse(request, 'generateOtpUserByBank1').subscribe((data: IbResponse) => {
        this.isLoad = false;
        response = data;
        console.log("response ");
        if (response !== null) {
          console.log('Otp :' + response.param1);
          this.isshow = 'page1';
        } else if (response !== null) {
          this.error = response.param1;
        } else {

          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    
  }
    removeMessages()
  {
    this.captchaInput="";
    this.confirmPassword="";
    this.confirmUserName="";
    this.newPass="";
    this.newUserName="";
    this.messageFormNewPassreq="";
    this.msgforNewPassSplChar="";
    this.msgforNewPassLen="";
    this.messageForOneCapital="";
    this.messageForOneNumber="";
    this.msgforNewPassSpace="";
    this. msgConfPassrequired="";
    this.confpassNotMatch="";
    this.msgOtprequired="";
    this.captchatNoblank="";
    this.msgForDateReq="";
    this.incorrectCaptcha="";
    this.messageNewUserreq="";
    this.msgforNewUserNoSpace="";
    //this.getCaptcha();
  }
  newUserNameAssignByBank()
  {
    if(this.validateNewUserName1() && this.validateConfUserName() && this.validateNewPassword() && this.validateConfPassword() && this.validateCaptcha() ){
    const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
     this.oldUserName=sessionStorage.getItem('storedUserName');
    this.oldPassword=sessionStorage.getItem('oldpasss');
       request.param1= getHexAscii("",this.oldUserName+this.newUserName+this.newPass+this.oldPassword);
        request.param2= this.oldUserName;
        
        request.param3= this.newUserName;
        request.param4= this.newPass;
        request.param5= this.oldPassword;
    console.log('sdfsdf'+request.param2+"wefef"+request.param3+'sdfsdf'+request.param4+'asff'+request.param5);
     this.webService.getResponse(request, 'newUserNameAssignByBank').subscribe((data: IbResponse) => {
        this.isLoad=false;
      this.otpResponse=data;
      if (this.otpResponse.status === 'S101'){
        alert('Malicious Request Detected');
        //this.router.navigate(['/log']);
      }
      else if(this.otpResponse.status==='S200'){   
            this.toastr.success('',this.otpResponse.param1);
        //alert(this.otpResponse.param1);
       //sessionStorage.setItem('showSuccessMsg',response.param1);
        sessionStorage.removeItem('storedUserName');
   sessionStorage.removeItem('oldpasss');
         this.router.navigate(['/login']); 
      }
      else if(this.otpResponse.status==='USER_ALLREADY_EXIST'){
        alert(this.otpResponse.param1);
        this.isError1=true;
        this.error=this.otpResponse.param1;
       
        this.getCaptcha();
        this.captchaInput='';

      }
      else{

         this.isError1 = true;
          // tslint:disable-next-line:no-unused-expression
          //response.statusDescription;
          this.errorDescription = response.param1;
         
        this.getCaptcha();
        this.captchaInput='';
        this.error=this.otpResponse.param1;
        this.isLoad = false;
      }
      });
    }
  }

  validateNewUserName1(){
    let newuser=this.newUserName;
    if (newuser === '' ||newuser===' ' ||newuser===undefined ||newuser===null) 
    {
     this.messageNewUserreq = 'no';
     this. Errorflaguser='no';
     return false;
   }else if(newuser.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
       this. Errorflaguser='no';
       return false;
     }else if(newuser.match(this.regsplchar)){
       console.log('spl char----');
      this.msgforNewUserNoSpace='splchar';
      this. Errorflaguser='no';
      return false;
     }else if(this.messageNewUserreq==='userExist'){
       console.log('do nothing----');
     } else{
      this.messageNewUserreq = '';
      this.msgforNewUserNoSpace='';
      this. Errorflaguser='';
      return true;
     }
  }
 validateNewUserName()
  {
    let newuser=this.newUserName;
    if (newuser === '' || newuser===' ' ||newuser===undefined||newuser===null) 
    {
     this.messageNewUserreq = 'no';
     this. Errorflaguser='no';
         return;
   }else if(newuser.match(this.regexpspace))
    {
      this.msgforNewUserNoSpace='no';
       this. Errorflaguser='no';
       return;
     }else if(newuser.match(this.regsplchar)){
       console.log('spl char----');
      this.msgforNewUserNoSpace='splchar';
      this. Errorflaguser='no';
     }  else{
       this. Errorflaguser='yes';
       this.msgforNewUserNoSpace='';
       const request: IbRequest = new IbRequest();
       let response: IbResponse = null;
      this.oldUserName=sessionStorage.getItem('storedUserName');
     this.oldPassword=sessionStorage.getItem('oldpasss');
        request.param1= getHexAscii("",this.oldUserName+this.newUserName+this.newPass+this.oldPassword);
         request.param2= this.oldUserName;
         
         request.param3= this.newUserName;
         request.param4= this.newPass;
         request.param5= this.oldPassword;
       this.webService.getResponse(request, 'checkForIBUserExistOnBlur').subscribe((data: IbResponse) => {

        if(data.status==='USER_ALLREADY_EXIST'){
          console.log('same user exist!!');
          this.messageNewUserreq='userExist';
          this. Errorflaguser='no';
          this.error=data.param1;
          
        }else{
          this.messageNewUserreq='';
          this.error='';
        }

       });

     }
  
  }
  clearNewUserName()
  {
    this.messageNewUserreq='';
     this.msgforNewUserNoSpace='';
  }
validateConfUserName()
  {
    let confuser=this.confirmUserName;
    if (confuser === '' ||confuser===' ' ||confuser===undefined||confuser===null) 
    {
     this.messageConfUserreq = 'no';
      this.ErrorflagCfUser="no";
      return false;
   }else if(confuser.match(this.regexpspace))
    {
      this.msgforConfUserNoSpace='no';
       this.ErrorflagCfUser="no";
       return false;
     }else if(confuser!==this.newUserName)
     {
       this.msgforConfUserNoSpace='unmatch';
        this.ErrorflagCfUser="no";
        return false;
      }else{
        this.messageConfUserreq = '';
        this.ErrorflagCfUser="yes";
     //   this.msgforNewUserNoSpace='';
      return true;
     }
  }
  clearConfUserName()
  {
    this.messageConfUserreq='';
    this.msgforConfUserNoSpace='';
  }
   validateNewPassword()
  {
    let newPass=this.newPass;
    if (newPass === '' ||newPass===' ' ||newPass===undefined||newPass===null) 
    {
     this.messageFormNewPassreq = 'no';
      this. ErrorflagPass="no";
      return false;
   }else if(newPass.match(this.regexpspace))
    {
      this.msgforNewPassSpace= 'no';
       this. ErrorflagPass="no";
       return false;
     }else if(!newPass.match(this.regsplchar))
    {
      this.msgforNewPassSplChar= 'no';
       this. ErrorflagPass="no";
       return false;
     }else if(newPass.length<8)
    {
      this.msgforNewPassLen = 'no';
       this. ErrorflagPass="no";
       return false;
     }
     else if(!newPass.match(this.regexcap))
    {
      this.messageForOneCapital='no';
       this. ErrorflagPass="no";
       return false;
    }
      else if(!newPass.match(this.regNum))
    {
      this.messageForOneNumber='no';
       this. ErrorflagPass="no";
       return false;
    }else{
       this. ErrorflagPass="yes";
       this.messageForOneNumber='';
       return true;
    }
  }
  clearNewPassword()
  {
     this.messageFormNewPassreq="";
      this.msgforNewPassSpace='';
      this.msgforNewPassSplChar="";
      this.msgforNewPassLen="";
      this.messageForOneCapital="";
      this.messageForOneNumber="";
  }
   validateConfPassword()
  {
    let newpass:string=this.newPass;
    let confpass:string=this.confirmPassword; 
    if (confpass === '' ||confpass===' ' || confpass===undefined ||confpass===null) 
    {
     this.msgConfPassrequired='no';
       this. ErrorflagCfPass="no";
       return false;
    }else if(!(newpass===confpass))
      {
      this.confpassNotMatch='no';
      this. ErrorflagCfPass="no";
      return false;
    }else{
      this.confpassNotMatch='';
      this.msgConfPassrequired='';
      this. ErrorflagCfPass="yes";
      return true;
    }
    
  }
  clearConfPassword()
  {
    this.msgConfPassrequired='';
    this.confpassNotMatch='';
     
  }
  validateCaptcha()
  {
    let captcha=this.captchaInput;
    let captchaWithoutSpaceNew = this.captcha.split(' ').join('');
    if (captcha === '' ||captcha===' ' ||captcha===undefined||captcha===null) 
    {
     this.captchatNoblank = 'no';
      this.Errorflagcap="no";
      return false;
   }else if(captcha!==captchaWithoutSpaceNew)
     {
      this.incorrectCaptcha='no';
       this.Errorflagcap="no";
       return false;
    }
   else{
     this.captchatNoblank = '';
     this.incorrectCaptcha='';
      this.Errorflagcap="yes";
      return true;
   }
  }
  clearCaptcha()
  {
    this.captchatNoblank='';
    this.incorrectCaptcha='';
  }
    validateOtp()
  {
    let otp=this.otp;
    if (otp === '' ||otp===' ' ||otp===undefined||otp===null) 
    {     
     this.msgOtprequired = 'no';
      this.ErrorflagOtp="no";
   }else{
      this.ErrorflagOtp="yes";
   }
  
  }
  clearOtp()
  {
    console.log("clear");
    this.msgOtprequired='';
  }
openPage2(){
  this.isshow='show';
  this.getCaptcha();
  this.validateCaptcha();
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/new-user-by-bank/new-user-by-bank.component.ts